<template>
  <div class="app-about-area pb-100 pt-100 mt-5">
    <div class="container-fluid">
      <div class="row align-items-center about-row">
   

        <div class="col-lg-6 col-md-12">
          <div class="app-about-content">
            <!-- <div class="big-text">About Us</div> -->
            <span class="sub-title text-uppercase">We Are</span>
            <h2 class="app-about-title">
             Who We Are
            </h2>
            <p>
             Founded in 2014, Meander Software is a Top Rated Plus development agency bridging innovation across India and the USA. Our team of over 100 experts specializes in full-stack mobile and web solutions, cloud services, and digital marketing—bringing your most ambitious ideas to life.
            </p>
            <ul class="list">
              <li>
                <div class="icon">
                  <i class="ri-award-line"></i>
                </div>
                <h3>Core Values</h3>
                <p>
                At Meander Software, integrity, innovation, collaboration, and client satisfaction are our guiding principles. We prioritize ethical conduct, continuously seek new solutions, foster teamwork, and aim to exceed client expectations. These values shape our culture and drive our commitment to excellence in every project.
                </p>
              </li>
              <li>
                <div class="icon bg2">
                  <i class="ri-download-cloud-2-line"></i>
                </div>
                <h3>Our Vision</h3>
                <p>
                 Meander Software imagines a future where technology enhances life for all. Our aim is to craft inventive solutions, breaking barriers for a more accessible digital world. Through creativity and determination, we empower individuals and businesses to flourish in a more connected environment
                </p>
              </li>
              <li>
                <!-- <div class="icon bg2">
                  <i class="ri-download-cloud-2-line"></i>
                </div>
                <h3>our vision</h3> -->
                <button @click="openCalendly" class="default-btn">
                Schedule Demo
              </button>
              </li>
            </ul>
            <!-- <div class="btn-box">
              <button @click="openCalendly" class="default-btn">
                Schedule Demo
              </button>
            </div> -->
          </div>
        </div>

             <div class="col-lg-6 col-md-12">
          <div class="app-about-image">
            <img
              src="../../../assets/images/more-home/about/First-images.png"
              alt="image"
            />
                      <img src="../../../assets/images/Technical-animation.png" alt="shape animation" class="app-about-animation" />

          </div>
        </div>
      </div>
    </div>

  
    <div class="app-about-shape-2" style="left: 30px; right:auto;">
      <img
        src="../../../assets/images/more-home/about/shape-2.png"
        alt="image"
      />
    </div>
      <div class="app-about-shape-1" style="right: 30px; left:auto;">
      <img
        src="../../../assets/images/more-home/about/shape-1.png"
        alt="image"
      />
    </div>
    <div class="app-about-shape-3">
      <img
        src="../../../assets/images/more-home/about/shape-3.png"
        alt="image"
      />
    </div>
  </div>
</template>
<style>
img.app-about-animation {
  display: none;
}
@media screen and (max-width: 767px) {
  .about-row {
    flex-direction: column-reverse;
  }
  .about-row .app-about-content {
    margin-top: 0px;
}
img.app-about-animation {
    position: absolute;
    right: 40px;
    bottom: -60px;
    width: 60px;
    animation: movebounce 5s linear infinite;
    display: block;
}
.app-about-image {
    position: relative;
}
.app-about-area {
    padding-bottom: 40px;
}
.app-about-area {
    padding-bottom: 40px;
}

}
</style>
<script>
export default {
  name: "About",
  methods: {
    openCalendly() {
      // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({
        url: "https://calendly.com/connect-to-meander/30min",
      });
      return false;
    },
  },
};
</script>
